import React from "react";
import cx from "classnames";

import styles from "./LineIndicator.module.scss";

export interface LineIndicatorProps
  extends React.ComponentPropsWithoutRef<"ol"> {
  currentIndex: number;
  numberOfImages: number;
}

export const LineIndicator = ({
  currentIndex,
  numberOfImages,
  className,
  ...props
}: LineIndicatorProps) => {
  const classNames = cx(styles.lineIndicator, className);
  return (
    <ol
      data-testid="standard:gallery:line-indicator"
      className={classNames}
      {...props}
    >
      {[...Array(numberOfImages)].map((_, idx) => (
        <li
          className={cx({ [styles.current]: idx === currentIndex })}
          key={idx}
        />
      ))}
    </ol>
  );
};
